import React from 'react';
import { Divider, Popconfirm } from 'antd';

export const statusMap = {
  on: '正常',
  todo: '待处理',
  added: '已创建知识点',
  related: '已关联现有问题',
  ignored: '已忽略',
};
export default self => [
  {
    title: '问题',
    dataIndex: 'desc',
    key: 'desc',
  },
  {
    title: '询问次数',
    dataIndex: 'ask_times',
    key: 'ask_times',
  },
  {
    title: '问题状态',
    dataIndex: 'status',
    key: 'status',
    render: (t, r) => {
      if (t === 'related') {
        return `已关联：${r.question_title}`;
      } else if (t === 'added') {
        return `已添加知识点：${r.question_title}`;
      }
      return statusMap[t];
    },
  },
  {
    title: '组织机构',
    dataIndex: 'organization_name',
    key: 'organization_name',
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 380,
    render: (t, item) => (
      <div>
        {item.status === 'todo' && (
          <span>
            <a
              onClick={() => {
                self.setModals({
                  key: 'addQuestionModal',
                  title: '添加到知识库',
                  visible: true,
                  item,
                });
              }}
            >
              添加到知识库
            </a>
            <Divider type="vertical" />
            <a
              onClick={() => {
                self.setModals({
                  key: 'relatedQS',
                  title: '关联为相似问题',
                  visible: true,
                  item,
                });
              }}
            >
              关联为相似问题
            </a>
            <Divider type="vertical" />
          </span>
        )}
        <a onClick={() => self.displayContext(item)}>查看会话记录</a>
        <Divider key="1" type="vertical" />
        <Popconfirm
          key="2"
          title="确认忽略该问题？"
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() =>
            self.handleIgnore(item.id, item.status === 'ignored')
          }
        >
          <a>{item.status === 'ignored' ? '撤销忽略' : '忽略'}</a>
        </Popconfirm>
      </div>
    ),
  },
];
